var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.11198 10.6226L5.68245 9.80132L5.11198 10.6226ZM1.68801 10.835L2.56629 11.3131L1.68801 10.835ZM3.24247 17.6368C2.99769 18.1319 3.20058 18.7317 3.69566 18.9765C4.19073 19.2212 4.7905 19.0183 5.03529 18.5233L3.24247 17.6368ZM5.68245 9.80132C5.13687 9.42238 4.29981 9.04481 3.42715 8.98444C2.5048 8.92064 1.42648 9.22395 0.809722 10.3569L2.56629 11.3131C2.70556 11.0573 2.90542 10.9531 3.28914 10.9797C3.72256 11.0097 4.21946 11.2203 4.54151 11.444L5.68245 9.80132ZM0.809722 10.3569C0.26696 11.3539 0.409623 12.287 0.820358 13.065C1.18382 13.7535 1.798 14.3891 2.24768 14.8834C2.75215 15.4379 3.12242 15.884 3.31105 16.3334C3.47007 16.7122 3.50573 17.1044 3.24247 17.6368L5.03529 18.5233C5.57108 17.4397 5.52479 16.4399 5.15519 15.5593C4.81522 14.7494 4.21023 14.0686 3.7271 13.5376C3.1892 12.9463 2.80346 12.5375 2.58902 12.1313C2.42185 11.8146 2.40861 11.6028 2.56629 11.3131L0.809722 10.3569ZM4.54151 11.444C5.5291 12.1299 6.5919 12.045 7.33504 11.616L6.33504 9.8839C6.26607 9.92372 6.17666 9.95099 6.077 9.94864C5.98462 9.94647 5.85105 9.91843 5.68245 9.80132L4.54151 11.444Z",
    fill: "#1F305E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89728 2.05383C10.3756 1.77769 10.9872 1.94157 11.2633 2.41986L16.2633 11.0801C16.5394 11.5584 16.3756 12.17 15.8973 12.4461L12.4332 14.4461C10.9983 15.2746 9.16353 14.7829 8.3351 13.3481L5.3351 8.15191C4.50668 6.71703 4.9983 4.88226 6.43318 4.05383L9.89728 2.05383Z",
    fill: "#2A4384",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3613 3.51794C15.8396 3.2418 16.0035 2.63021 15.7274 2.15192C15.4512 1.67362 14.8396 1.50975 14.3613 1.78589L15.3613 3.51794ZM18.3613 8.71409C18.8396 8.43795 19.0035 7.82636 18.7274 7.34807C18.4512 6.86978 17.8396 6.7059 17.3613 6.98204L18.3613 8.71409ZM14.3613 1.78589L11.7633 3.28589L12.7633 5.01794L15.3613 3.51794L14.3613 1.78589ZM17.3613 6.98204L14.7633 8.48204L15.7633 10.2141L18.3613 8.71409L17.3613 6.98204Z",
    fill: "#1F305E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsIcon);
export default __webpack_public_path__ + "static/media/integrations-icon.404133216b981bf4b26118694fd1b035.svg";
export { ForwardRef as ReactComponent };